import IconButton from '@material-ui/core/IconButton';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { colors } from 'design-system';
import React, { ReactElement } from 'react';
import { Search } from 'react-feather';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.onahau,
      height: theme.spacing(10),
      padding: theme.spacing(1.5),
      width: '100%',
    },
    searchArea: {
      height: theme.spacing(5.75),
      minWidth: theme.spacing(31.75),
      borderRadius: theme.spacing(1.25),
      paddingLeft: theme.spacing(1.5),
      fontFamily: 'Noto Sans SC',
      fontSize: theme.spacing(2),
      border: 'none',
      marginRight: theme.spacing(2),
      '&:focus': {
        outline: 'none',
      },
    },
    searchBtn: {
      backgroundColor: colors.bright_turquoise,
      minWidth: theme.spacing(10.25),
      minHeight: theme.spacing(6.25),
      borderRadius: theme.spacing(10),
      '&:hover': {
        backgroundColor: colors.bright_turquoise,
      },
      '&:active': {
        backgroundColor: colors.madison,
      },
    },
  }),
);

interface Props {
  inputName: string;
  placeholder?: string;
  defaultValue: string;
  onChange: (newVal: string) => void;
  onSubmit: () => void;
}

export default function InspectionSearchBar({
  inputName,
  placeholder,
  defaultValue,
  onChange,
  onSubmit,
}: Props): ReactElement {
  const classes = useStyles();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onSubmit();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    onChange(value);
  };

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <input
        className={classes.searchArea}
        name={inputName}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={handleChange}
        id="sales-web-input-inspectionsearch"
      />
      <IconButton
        className={classes.searchBtn}
        id="sales-web-button-inspectionsearchbutton"
        onClick={onSubmit}
        data-testid="submit-btn"
      >
        <Search width={28} height={28} color={colors.white} />
      </IconButton>
    </form>
  );
}
